module.exports = __webpack_public_path__ + "media/steps/loader_icon_2_old-2a5031de.png";